//style
import "../styles/components/loadingPage.scss";
const LoadingPage = () => {
  return (
    <div className="loadingPage w-100">
      <h1 className=" m-auto"> ... در حال آماده سازی </h1>
    </div>
  );
};

export default LoadingPage;
